import styled from 'styled-components'

export const RadioContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
`

export const SubmitContainer = styled.div`
  width: 100%;
`

export const InputContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  width: 100%;
`

export const Text = styled.p`
  font-size: ${(props) => props.theme.font.textcaption};
  color: ${(props) => props.theme.color.purple.purple900};
  font-weight: 400;
  letter-spacing: 0.003rem;
`

export const FormRadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 1rem;
  cursor: pointer;
`

export const RadioInput = styled.input.attrs({ type: 'radio' })`
  appearance: none;
`

interface RadioProps {
  isChecked: boolean
}

export const RadioAppearence = styled.label<RadioProps>`
  min-width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.color.purple.purple700};
  background: ${(props) =>
    props.isChecked
      ? props.theme.color.purple.purple800
      : props.theme.color.blue.blue50};
  padding: 0.6875rem 1rem;
  color: ${(props) =>
    props.isChecked
      ? props.theme.color.neutral.white
      : props.theme.color.purple.purple800};
  font-size: ${(props) => props.theme.font.textsm};
  font-weight: 500;
  letter-spacing: 0.05rem;
  cursor: pointer;
`
